import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_male_managers'

export const dataPointDefinition = {
  retracedId: 'num_of_male_managers',
  name: 'Number of male managers:',
  description:
    'Managers are persons who manage staff, and the planning and evaluation of department activities. Managers also maintain staff by recruiting, selecting, orienting, and training staff. Examples are department heads like HR Manager, QA Manager, OSH Manager, Compliance Manager, Production Manager. Managers are also Line Managers or managers of specific production processes like Cutting Department Manager, Sewing Department Manager, Scheduling Manager etc. ',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-35',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1860,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
